import React from "react";
import "../../style/uploadDownload.css";
import { NavLink } from "react-router-dom";
import img from '../../assets/Integration_Testing_Flowchart.jpg'

function UploadDownload() {
  return (
    <div className="upload-container">
      <h1 className="page-title">Upload and Download</h1>

      <h6 className="section-title">
        <strong>Download</strong>
      </h6>

      <p>
        <NavLink
          to={img}
          target="_blank"
          rel="noreferrer"
          id="downloadButton"
          download="sampleFile.jpeg"
          className="download-btn"
        >
          Download
        </NavLink>
      </p>

      <h6 className="section-title upload-title">
        <strong>Select a File to Upload</strong>
      </h6>

      <form>
        <div className="file-upload-box">
          <label htmlFor="uploadFile" className="file-label">
            Select a file
          </label>

          <input
            id="uploadFile"
            type="file"
            className="file-input"
            lang="en"
          />
        </div>
      </form>
    </div>
  );
}

export default UploadDownload;